import Button from "./Button";
import { ButtonProps } from "./types";

export default Button;
export type { ButtonProps };
